export enum ServiceName {
  Api,
  DocumentCatalogueApi,
  DocumentCatalogueOData,
  GraphApi,
  TimelineApi
}